module.exports = __webpack_public_path__ + "img/withdraw_details.c36602d6.svg";